export default "__VITE_ASSET__BBczceIC__"